var loginDOTD = function () {
	const formLogin = new forms4i();
	const helpers = new formHelpers4i();
	const submitBtn = document.getElementById("logonSubmit");
	const logonForm = document.getElementById("logonForm");
	let recaptchaActionName;

	const init = () => {
		if (submitBtn) {
			submitBtn.addEventListener("click", validateForm);

			formLogin.BindPasswordButtons(logonForm);
			//const passwords = new passwords4i();
			//passwords.Init(logonForm);
		}
	},
		validateForm = (e) => {
			e.preventDefault();
			helpers.ClearStatus();
			submitBtn.setAttribute("disabled", "disabled");
			helpers.ShowBusyBtn(submitBtn);
			/*formLogin.FormValidation({
				event: e,
				form: logonForm, 
				onSuccess: submitLogonForm,
				onFailure: enableSubmitButton
			});*/
			formLogin.formValidation(logonForm, submitLogonForm, e, enableSubmitButton);
		},
		enableSubmitButton = () => {
			helpers.ClearBusyBtn();
			submitBtn.removeAttribute("disabled");
		},
		submitLogonForm = async () => {
			const recaptchaSiteKey = document.querySelector("#RecaptchaSiteKeyLogon").value;
			recaptchaActionName = document.querySelector("#RecaptchaActionNameLogin").value;
			grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName }).then(function (token) {
				submitForm(token);
			});
			/*
await grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName }).then(async function(token){
await submitForm(token);
});*/
		},
		submitForm = async (token) => {
			const data = {
				EMailAddress: document.querySelector("#EMailAddress").value,
				Password: document.querySelector("#Password").value,
				RecaptchaActionNameLogin: recaptchaActionName,
				RecaptchaToken: token
			};
			const response = await fetch('/dealoftheday/sop/account/LogOnAjaxAsync', {
				method: 'POST',
				body: JSON.stringify(data),
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": document.querySelectorAll('input[name=__RequestVerificationToken]')[0] ? document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value : "" }
			})
				.then(function (response) {
					return (response.ok) ? response.json() : [];
				}).then(function (response) {
					if (response) {
						if (response.success) location.reload();
						else showError(response);
					}
				}).catch(function (error) {
					console.error(error);
					enableSubmitButton();
					helpers.ShowErrorStatus(submitBtn, "There was an error processing your sign in information. Please try again.");
					return false;
				});
		},
		showError = (result) => {
			enableSubmitButton();
			if (result.errorType == "Recaptcha") {
				submitBtn.insertAdjacentHTML('beforebegin', helpers.ErrorMsgPanel);
				document.getElementById('ErrorTitle').innerHTML = result.title;
				const errorBox = document.getElementById("ErrorMsgBox");
				errorBox.innerHTML = result.message;
				errorBox.focus();
			} else {
				helpers.ShowErrorStatus(submitBtn, result.message);
			}
		};
	return {
		Init: init
	};
};

(function () {
	const login = new loginDOTD();
	login.Init();
})();